import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import * as Sentry from "@sentry/react";
import { StytchB2BProvider } from "@stytch/react/b2b";
import { StytchB2BUIClient } from "@stytch/vanilla-js/b2b";
import env from "./env.ts";

Sentry.init({
  dsn: "https://1c9ccf13411fa3235926e68b3cf469b6@o4508690316197888.ingest.us.sentry.io/4508905376579584",
  integrations: [Sentry.browserTracingIntegration()],
  environment: import.meta.env.MODE,
  sampleRate: import.meta.env.PROD ? 1.0 : 0.0,

  // Tracing
  tracesSampleRate: import.meta.env.PROD ? 1.0 : 0.0, //  Capture 100% of the transactions
  tracePropagationTargets: [env.VITE_API_URL],
});

// optional object for configuring SDK cookie behavior, currently showing defaults
const stytchOptions = {
  cookieOptions: {
    opaqueTokenCookieName: "stytch_session",
    jwtCookieName: "stytch_session_jwt",
    availableToSubdomains: true,
    domain: import.meta.env.VITE_STYTCH_COOKIE_DOMAIN,
  },
};

const publicToken = import.meta.env.VITE_STYTCH_PUBLIC_TOKEN;
const stytch = new StytchB2BUIClient(publicToken, stytchOptions);

// biome-ignore lint/style/noNonNullAssertion: ...
const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <StytchB2BProvider stytch={stytch}>
    <App />
  </StytchB2BProvider>,
);
